import { Link } from 'react-router-dom'
import type { LucideIcon } from 'lucide-react'
import { Settings } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface HeaderNavigationItem {
  name: string
  href: string
  icon: LucideIcon
}

interface HeaderPrimaryNavProps {
  items: HeaderNavigationItem[]
  currentPath: string
}

export function HeaderPrimaryNav({ items, currentPath }: HeaderPrimaryNavProps) {
  return (
    <>
      <div className="border-t border-gray-200 md:hidden">
        <div className="overflow-x-auto">
          <div className="flex min-w-max gap-1 px-2 py-2">
            {items.map((item) => {
              const isActive = currentPath === item.href
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    'flex min-h-[60px] w-[86px] shrink-0 flex-col items-center justify-center rounded-lg px-2 py-3 text-xs font-medium transition-colors',
                    isActive ? 'bg-orange-50 text-orange-600' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'
                  )}
                >
                  <item.icon className="mb-1 h-5 w-5" />
                  <span className="text-center leading-tight">{item.name}</span>
                </Link>
              )
            })}

            <Link
              to="/instellingen"
              className={cn(
                'flex min-h-[60px] w-[86px] shrink-0 flex-col items-center justify-center rounded-lg px-2 py-3 text-xs font-medium transition-colors',
                currentPath === '/instellingen'
                  ? 'bg-orange-50 text-orange-600'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'
              )}
            >
              <Settings className="mb-1 h-5 w-5" />
              <span className="text-center leading-tight">Instellingen</span>
            </Link>
          </div>
        </div>
      </div>

      <div className="hidden border-t border-gray-200 md:block">
        <div className="container">
          <div className="overflow-x-auto">
            <div className="flex min-w-max items-center gap-2 py-3">
              {items.map((item) => {
                const isActive = currentPath === item.href
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={cn(
                      'flex shrink-0 items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-orange-100 text-orange-700'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                    )}
                  >
                    <item.icon className="h-4 w-4" />
                    <span className="whitespace-nowrap">{item.name}</span>
                  </Link>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
